import { gateway } from "../../../gateway";
import { ISecretDTO } from "../interfaces/ISecretDTO";

export const fetchPasswordsAction = async () => {
  const token = sessionStorage.getItem("token");

  const res = await gateway.get("/passwords", {
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });

  return (res.data?.data ?? res.data) as ISecretDTO[];
};
